<div class="section section--events" *ngIf="events.length > 0">
  <div class="container">
    <div class="section--titles-wrapper">
      <div
        class="section__title"
        [innerHTML]="eventsHeader.title | translate"
        style="--font:{{ font }}"
      ></div>
      <div class="section__subtitle" [innerHTML]="eventsHeader.subtitle | translate"></div>
    </div>
    <div class="events__slider">
      <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let item of events; index as i" class="slide">
          <app-event-box style="margin: 5px" [event]="item" [isHomepage]="true"></app-event-box>
        </div>
      </ngx-slick-carousel>
    </div>

    <div class="events-action">
      <button class="btn btn--primary btn--lg" [routerLink]="['/' + buttonLink]">
        {{ 'HOMEPAGE.show_more_events' | translate }}
      </button>
    </div>
  </div>
</div>
